import { render, staticRenderFns } from "./DisabledIcon.vue?vue&type=template&id=128b9153&scoped=true&"
import script from "./DisabledIcon.vue?vue&type=script&lang=js&"
export * from "./DisabledIcon.vue?vue&type=script&lang=js&"
import style0 from "./DisabledIcon.vue?vue&type=style&index=0&id=128b9153&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b9153",
  null
  
)

export default component.exports